import React, { Component } from 'react';
import { getModeIcon, isEmpty } from '../../../../Common/Common';

export default class Mode extends Component {
	constructor(props) {
		super(props);

		let mode = 'C';

		if (this.props.group_id == null) {
			if (!isEmpty(this.props.point_info)) {
				if (this.props.point_info.ch_master || this.props.point_info.mode == 'F' || this.props.point_info.mode == 'D') {
					mode = this.props.point_info.mode;
				} else {
					mode = 'T';
				}
			}
		} else {
			this.is_show_cool = false;
			this.is_show_heat = false;
			this.is_show_fan = false;
			this.is_show_dry = false;
			this.is_show_auto = false;

			// This is placed in the constructor to loop only once to get the capabilities of ACs in the group
			if (this.props.group_info != null) {
				for (let point_id of this.props.group_info.mp) {
					let point_info = window.app.state.point_list[point_id];
					if (!isEmpty(point_info)) {
						if (point_info.type == 'Ac') {
							if (!this.is_show_cool && point_info.mode_cap.C) this.is_show_cool = true;
							if (!this.is_show_heat && point_info.mode_cap.H) this.is_show_heat = true;
							if (!this.is_show_fan && point_info.mode_cap.F) this.is_show_fan = true;
							if (!this.is_show_dry && point_info.mode_cap.D) this.is_show_dry = true;
							if (!this.is_show_auto && point_info.mode_cap.A) this.is_show_auto = true;
						}
					}
				}
			}
		}

		this.state = {
			mode: mode,
			icon: getModeIcon(mode),
		}
	}

	handleChangeMode = () => {
		if(this.props.mode2Tapped) return;	//Do no process click if mode2 is tapped

		let new_mode = 'C';

		let mode = this.state.mode;
		if (this.props.group_id == null) {
			if (!isEmpty(this.props.point_info)) {
				switch (mode) {
					case 'C':
						if (this.props.point_info.mode_cap.H)
							new_mode = 'H';
						else if (this.props.point_info.mode_cap.F)
							new_mode = 'F';
						else if (this.props.point_info.mode_cap.D)
							new_mode = 'D';
						else if (this.props.point_info.mode_cap.A)
							new_mode = 'A';
						break;
					case 'H':
						if (this.props.point_info.mode_cap.F)
							new_mode = 'F';
						else if (this.props.point_info.mode_cap.D)
							new_mode = 'D';
						else if (this.props.point_info.mode_cap.A)
							new_mode = 'A';
						else if (this.props.point_info.mode_cap.C)
							new_mode = 'C';
						break;
					case 'F':
						if (this.props.point_info.mode_cap.D)
							new_mode = 'D';
						else if (this.props.point_info.mode_cap.A)
							new_mode = 'A';
						else if (this.props.point_info.mode_cap.C)
							new_mode = 'C';
						else if (this.props.point_info.mode_cap.H)
							new_mode = 'H';
						break;
					case 'D':
						if (this.props.point_info.mode_cap.A)
							new_mode = 'A';
						else if (this.props.point_info.mode_cap.C)
							new_mode = 'C';
						else if (this.props.point_info.mode_cap.H)
							new_mode = 'H';
						else if (this.props.point_info.mode_cap.F)
							new_mode = 'F';
						break;
					case 'A':
						if (this.props.point_info.mode_cap.C)
							new_mode = 'C';
						else if (this.props.point_info.mode_cap.H)
							new_mode = 'H';
						else if (this.props.point_info.mode_cap.F)
							new_mode = 'F';
						else if (this.props.point_info.mode_cap.D)
							new_mode = 'D';
						break;
					case 'T':
						if (this.props.point_info.mode_cap.F)
							new_mode = 'F';
						else if (this.props.point_info.mode_cap.D)
							new_mode = 'D';
						break;
					default:

				}

				if (!this.props.point_info.ch_master) {
					if (new_mode == 'C' || new_mode == 'H') new_mode = 'T'
				}
			}
		} else {
			switch (mode) {
				case 'C':
					if (this.is_show_heat) new_mode = 'H';
					else if (this.is_show_fan) new_mode = 'F';
					else if (this.is_show_dry) new_mode = 'D';
					else if (this.is_show_auto) new_mode = 'A';
					break;
				case 'H':
					if (this.is_show_fan) new_mode = 'F';
					else if (this.is_show_dry) new_mode = 'D';
					else if (this.is_show_auto) new_mode = 'A';
					else if (this.is_show_cool) new_mode = 'C';
					break;
				case 'F':
					if (this.is_show_dry) new_mode = 'D';
					else if (this.is_show_auto) new_mode = 'A';
					else if (this.is_show_cool) new_mode = 'C';
					else if (this.is_show_heat) new_mode = 'H';
					break;
				case 'D':
					if (this.is_show_auto) new_mode = 'A';
					else if (this.is_show_cool) new_mode = 'C';
					else if (this.is_show_heat) new_mode = 'H';
					else if (this.is_show_fan) new_mode = 'F';
					break;
				case 'A':
					if (this.is_show_cool) new_mode = 'C';
					else if (this.is_show_heat) new_mode = 'H';
					else if (this.is_show_fan) new_mode = 'F';
					else if (this.is_show_dry) new_mode = 'D';
					break;
				default:
			}
		}

		this.setState({
			mode: new_mode,
			icon: getModeIcon(new_mode)
		})

		this.props.handleChangeMode(new_mode);
	}

	render() {
		return (
			<div id='mode' style={this.props.style} onClick={this.handleChangeMode}>
				<div>
					<img src={this.state.icon} style={{ width: 40 }} />
				</div>

				<div>
					<span> {this.props.receiver.getString('mode')} </span>
				</div>
			</div>
		)
	}
}
